import * as audio from './kernel/audio.js';
import * as screen from './kernel/screen.js';
import * as remote from './programs/remote.js';
import * as dom from './dom.js';
import * as scene from './scene.js';

export {
    soundEffect,
    start,
    backgroundTrack,
}

// Development
window.DEVMODE = true;

// Config
window.LSI = 25; // Line Sequence Interval (Used in screen.sequence and unveil
                 // calls for line by line time interval in milliseconds)

// Sound references
let backgroundTrack = null;

function soundEffect(name) {
    // TODO: refactor this
    const effects = {
        'validate': { initialGain: -12, offset: 0.100, duration: 0.093 },
        'error': { initialGain: -12, offset: 0.200, duration: 0.175 },
        'success': { initialGain: -12, offset: 0.400, duration: 0.148 },
        'question': { initialGain: -12, offset: 0.600, duration: 0.131 },
        'notify': { initialGain: -12, offset: 0.800, duration: 0.340 },
        'connected': { initialGain: -18, offset: 1.200, duration: 0.147 },
        'disconnected': { initialGain: -18, offset: 1.400, duration: 0.297 },
        'connecting': { initialGain: -18, offset: 1.800, duration: 5.160 },
    };
    if (!(name in effects)) return console.error("Error: Uknown soundEffect: " + name);
    audio.buffers.play('ui-pack', effects[name]);
}

function init() {
    dom.init();
    dom.status('Initializing...');

    audio.init();
    screen.init();

    dom.status('Loading...');

    scene.init().then(() => {
        dom.showStart();
    });
}

function start() {
    backgroundTrack = audio.buffers.play('fan-loop', {
        loop: true,
        initialGain: -90,
    }).fadeTo(5, -8);

    remote.run('10.1.2.124');
}

init();
